import api from '@/api/report'
import { errorHandler } from "../exports/error_management"

const state = {
    items: [],
    customers: [],
    drivers: [],
}

const mutations = {
    set(state, payload) {
        state.items = payload
    },
    delete(state, id) {
        let index = state.items.findIndex(x => x.id == id)
        state.items.splice(index, 1)
    },
    set_drivers(state, payload) {
        state.drivers = payload
    },

    set_customers(state, payload) {
        state.customers = payload
    },

}

const actions = {
    fetch(context, payload) {
        return api
            .fetch(payload)
            .then(result => {
                let items = result.data.success.data.map(x => {
                    return x
                })
                context.commit('set', items)
                console.log('report-items', items)
            })
            .catch(err => {
                errorHandler(err)
            })
    },

    fetchDrivers(context) {
        return api.fetchDrivers(context).then(result => {
            let drivers = result.data.success.data.data
            context.commit('set_drivers', drivers)
        })
    },






}

const getters = {}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}